<template>
  <div>
    <div>
      <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
        <el-form-item label="电汇编号:" prop="billNum">
          <el-input v-model.trim="searchForm.billNum" placeholder="请输入电汇编号" />
        </el-form-item>
        <el-form-item label="汇入公司:" prop="billTo">
          <el-select v-model="searchForm.billTo" placeholder="请选择" clearable>
            <el-option
              v-for="item in companyList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
            <!-- <el-option value="锐捷网络股份有限公司" label="锐捷网络股份有限公司">锐捷网络股份有限公司</el-option>
            <el-option value="北京星网锐捷网络技术有限公司" label="北京星网锐捷网络技术有限公司">北京星网锐捷网络技术有限公司</el-option>
            <el-option value="上海锐山网络有限公司" label="上海锐山网络有限公司">上海锐山网络有限公司</el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="汇款日期:" prop="createBeginTime">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.createBeginTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">
              -
            </div>
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.createEndTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="tableLoading" @click="doSearch">
            搜索
          </el-button>
          <el-button type="default" @click="resetForm">
            重置
          </el-button>
          <!--<el-button type="primary">导出</el-button>-->
        </el-form-item>
      </el-form>
      <div v-loading="tableLoading" class="tableBody">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
          <el-table-column label="电汇底单编号" align="left" min-width="110" fixed="left">
            <template v-slot="{row}">
              <el-button type="text" @click="showInfo(row)">
                {{ row.teleTransferNum }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="remittanceAmount" label="汇入金额" align="right" header-align="left" width="100" />
          <el-table-column prop="account" label="汇入账户" align="left" />
          <el-table-column prop="billTo" label="汇入公司" align="left" />
          <el-table-column prop="arrivalDate" label="到款日期" align="left" />
          <el-table-column prop="usedAmount" label="已分配金额" align="right" header-align="left" width="100" />
          <el-table-column prop="unusedAmount" label="可用余额" align="right" header-align="left" width="100">
            <template v-slot="{row}">
              <span>{{ row.unusedAmount == null?0:row.unusedAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="importCompany" label="代理名称" align="left" />
          <el-table-column prop="summary" label="摘要" align="left" />
          <el-table-column prop="isDelete" label="状态" align="left">
            <template v-slot="{row}">
              <span v-if="row.isDelete">
                废弃
              </span>
              <span v-else>
                正常
              </span>
            </template>
          </el-table-column>
          <el-table-column label="分配" width="70" align="left" fixed="right">
            <template v-slot="{row}">
              <span v-if="row.isDelete">
                --
              </span>
              <span v-else>
                <el-button type="text" @click="toBill(row)">分配</el-button>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="操作" width="120" align="left" fixed="right">
            <template v-slot="{row}">
              <span v-if="row.isDelete">
                --
              </span>
              <span v-else>
                <el-button v-if="row.refund==0" type="text" @click="showApply(row)">申请退款</el-button>
                <el-button v-else-if="row.refund==1" type="text" @click="cancelApply(row)">取消申请</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right;margin-top: 10px">
          <el-pagination
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.currentPage"
            layout="total, prev, pager, next, jumper,sizes"
            :total="page.total"
            hide-on-single-page
            @size-change="handerSizeChange"
            @current-change="handerCurrentChange"
          />
        </div>
      </div>
    </div>
    <el-dialog title="电汇底单详细信息" :visible.sync="remittanceVisible" width="800px">
      <remittance-info-box v-if="remittanceVisible" :id="remittanceInfoID" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="remittanceVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="退款" :visible.sync="applyVisible" width="800px">
      <remittance-apply-box v-if="applyVisible" :id="remittanceInfoID" @close="changeApplyVisible" @set-loading="(isTrue) => isSubmitLoading = isTrue" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="applyVisible = false">取 消</el-button>
        <el-button :loading="isSubmitLoading" type="primary" @click="submitApply">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="es6">
import remittanceInfoBox from './components/remittanceInfoBox';
import remittanceApplyBox from './components/remittanceApplyBox';
import { billList, checkApplyCount, cancelApplyForRefund, getDictData } from '@/API/index';
import eventBus from '@/libs/eventBus';
export default {
  data () {
    return {
      searchForm: {
        billNum: '',
        billTo: '',
        createBeginTime: '',
        createEndTime: ''
      },
      tableData: [{}],
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 100,
        currentPage: 1
      },
      remittanceInfoID: '', // 电汇底单编号
      remittanceVisible: false, // 电汇底单详情
      applyVisible: false, // 申请退款
      applyInfo: [],
      ischeck: true,
      companyList: [],
      isSubmitLoading: false
    };
  },
  components: {
    remittanceApplyBox,
    remittanceInfoBox
  },

  created () {
    this.querySelectData();
    this.remittList();
  },

  methods: {
    querySelectData () {
      getDictData(['bank_name']).then((res) => {
        const { status, data } = res.data;
        if (status === '200') {
          this.companyList = data.find(row => row.dictType === 'bank_name').dictDataVOS;
        }
      });
    },

    doSearch () {
      this.currentPage = 1;
      this.remittList();
    },
    resetForm () {
      this.searchForm.createEndTime = '';
      this.$refs.searchForm.resetFields();
      this.remittList();
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    showInfo (row) {
      this.remittanceVisible = true;
      this.remittanceInfoID = row.teleTransferNum;
    },
    async showApply (row) {
      let ischeck = 'true';
      let res = await checkApplyCount(row.teleTransferNum);
      let json = res.data;
      if (json.status === '200') {
        ischeck = json.data;
      } else {
        this.$message.warning('接口发生错误');
        return false;
      }

      if (ischeck === 'true') {
        this.applyVisible = true;
        this.remittanceInfoID = row.teleTransferNum;
      } else {
        this.$message.warning('已经申请过退款');
      }
    },
    remittList () {
      this.tableLoading = true;
      billList({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
          this.tableLoading = false;
        } else {
          this.tableData = [];
          this.page.currentPage = 1;
          this.page.total = 0;
          this.tableLoading = false;
        }
      }).catch((res) => {

      });
    },
    toBill (row) {
      let companyName = row.importCompany;
      let teleTransferNum = row.teleTransferNum;
      let unusedAmount = row.unusedAmount;
      this.$router.push({ name: 'distributionRemittance', params: { orderUnit: companyName, teleNum: teleTransferNum, unusedAmount: unusedAmount } });
    },
    // 确认提交退款信息
    submitApply () {
      eventBus.$emit('submitApplyInfo');
    },
    changeApplyVisible (val) {
      this.applyVisible = val;
      this.remittList();
    },
    // 取消退款申请
    cancelApply (row) {
      cancelApplyForRefund(row.teleTransferNum, 0).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('取消退款申请已成功');
          this.remittList();
        }
      }).catch((res) => {

      });
    }
  }
};
</script>
